import React, { useContext, useState } from "react";
import FormTriggers from "../../../layouts/FormTriggers";
import RadioButtons from "../../../layouts/RadioButtons";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  getCompletedStepDetails,
  holdCaseMessage,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const PreviousLoan = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, visibilityObj, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType } = stepDetails;
  const {
    finance_lead_id,
    id,
    stage,
    sub_stage,
    insurance,
    bank_id,
    is_prepayment_raised,
    is_previous_loan,
    is_loan_clouser,
    step_details,
    maker_id,
  } = caseDetails;

  const initialState = {
    isPreviousLoan: is_previous_loan,
    isLoanClosure: is_loan_clouser,
  };
  const [state, setState] = useState(initialState);

  // Check visibility conditions for each field
  const isPreviousLoanVisible =
    requiredSubStepFields?.previous_loan?.is_visible === 1 &&
    visibilityObj.previous_loan_check;
  const isLoanClosureVisible =
    requiredSubStepFields?.loan_closure?.is_visible === 1 &&
    visibilityObj.previous_loan_closure;

  // Check if any field requires verification
  const calculatedIsVerificationRequired =
    isPreviousLoanVisible || isLoanClosureVisible;

  const saveDetails = async () => {
    const stepDetails = getCompletedStepDetails(
      step_details,
      sub_stage,
      stepSelected
    );
    await axios_instance({
      url: "/dts/dtsAdditionalDetails",
      method: "POST",
      data: {
        finance_lead_id: +finance_lead_id,
        form: stepSelected,
        stage: +stage,
        sub_stage: +sub_stage,
        type: btnDraftType,
        step_details: stepDetails,
        insurance,
        bank_id,
        is_prepayment_raised,
        is_previous_loan: state.isPreviousLoan,
        is_loan_closure: state.isLoanClosure,
        disbursement_id: +id,
      },
    });
    await fetchCaseData();
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };
  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="previous_loan">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isPreviousLoanVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.previous_loan?.name}
                          isRequired={false}
                          className="rto"
                          name="previous_loan_check"
                          disabled={
                            requiredSubStepFields?.previous_loan
                              ?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={
                            parseInt(state.isPreviousLoan) === 1 ? true : false
                          }
                          noChecked={
                            parseInt(state.isPreviousLoan) === 0 ? true : false
                          }
                          onYesClicked={() =>
                            setState({ ...state, isPreviousLoan: "1" })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isPreviousLoan: "0" })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="previous_loan_check"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isLoanClosureVisible && +state.isPreviousLoan ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.loan_closure?.name}
                          isRequired={false}
                          className="rto"
                          name="previous_loan_closure"
                          disabled={
                            requiredSubStepFields?.loan_closure?.is_editable ===
                            1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={
                            parseInt(state.isLoanClosure) === 1 ? true : false
                          }
                          noChecked={
                            parseInt(state.isLoanClosure) === 0 ? true : false
                          }
                          onYesClicked={() =>
                            setState({ ...state, isLoanClosure: "1" })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isLoanClosure: "0" })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="previous_loan_closure"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default PreviousLoan;
